import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { SlideSwitch } from '@els/els-react--slide-switch';
import { Button } from '@els/els-react--button';
import SelectAllItemsControls from '@Containers/ResultToolbar/SelectedItemsControls/SelectAllItemsControls';
import { createProjectFromRtStep } from '@Pages/Conditions/ConditionsService';
import { goToCreatedConditionsProject } from '@Pages/Conditions/navigation';
import { trackRtExploreConditionsSidePanel } from '@Pages/Conditions/analytics';

import './StepSelectionHeader.scss';

/* eslint-disable react-hooks/exhaustive-deps */
function StepSelectionHeader({
  selectedRowsCount,
  maxRowsCount,
  isPredicted,
  selectAllHandler,
  isViewOnlySelected,
  setViewOnlySelected,
  stepContext,
}) {
  const history = useHistory();
  const [isAllRowsSelected, setAllRowsSelected] = useState(false);
  const [isCreatingConditions, setIsCreatingConditions] = useState(false);

  const checkAllSteps = (selected) => {
    setAllRowsSelected(selected);
    selectAllHandler(selected);
  };

  useEffect(() => {
    if (isAllRowsSelected && selectedRowsCount < maxRowsCount) {
      setAllRowsSelected(false);
    } else if (!isAllRowsSelected && selectedRowsCount > 0 && selectedRowsCount === maxRowsCount) {
      setAllRowsSelected(true);
    }
  }, [selectedRowsCount]);

  const handleExploreConditions = async () => {
    if (!stepContext || isCreatingConditions) return;
    trackRtExploreConditionsSidePanel();
    setIsCreatingConditions(true);
    try {
      const project = await createProjectFromRtStep({
        projectId: stepContext.projectId,
        routeId: stepContext.routeId,
        step: stepContext.stepId,
      });
      goToCreatedConditionsProject(history, project);
    } catch (error) {
      Logger.error('StepSelectionHeader explore conditions failed with error:', error);
      setIsCreatingConditions(false);
    }
  };

  return (
    <div className={`project-route-step-selection ${isPredicted ? 'project-route-step-selection--predicted' : ''}`}>
      <SelectAllItemsControls
        checkAllItems={checkAllSteps}
        allItemsSelected={isAllRowsSelected}
        currentSelectedItems={selectedRowsCount}
        someItemsSelected={selectedRowsCount > 0 && selectedRowsCount < maxRowsCount}
      />
      <div className="project-route-step-selection--view-selected-wrapper">
        <SlideSwitch
          data-e2e="step-selection-view-selected"
          label="View selected"
          disabled={selectedRowsCount === 0}
          checked={isViewOnlySelected}
          onChange={(event) => setViewOnlySelected(event, event?.currentTarget?.checked)}
          e2eName="viewSelected"
        />
      </div>
      <Button
        data-e2e="explore-conditions-from-step-selection"
        type="secondary"
        size="small"
        className="u-els-margin-left"
        disabled={isCreatingConditions}
        onClick={handleExploreConditions}>
        Explore conditions
      </Button>
    </div>
  );
}

StepSelectionHeader.propTypes = {
  selectedRowsCount: PropTypes.number,
  maxRowsCount: PropTypes.number,
  selectAllHandler: PropTypes.func,
  setViewOnlySelected: PropTypes.func,
  isViewOnlySelected: PropTypes.bool,
  isPredicted: PropTypes.bool,
  stepContext: PropTypes.shape({
    projectId: PropTypes.string,
    routeId: PropTypes.string,
    stepId: PropTypes.string,
    routeType: PropTypes.string,
  }),
};

export default StepSelectionHeader;
